import React, { useState } from 'react';
import styled from 'styled-components';
import Pagination from '../../components/pagination/Pagination';
import AddInterestReportModal from './AddInterestReportModal';
import { groupProps, QuantProps } from '../QuantReport';
import QuantService from '../../../service/quant/Quant';
import { userGradeType } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

import ThemeModal from './ThemeModal';

interface Props {
  list: QuantProps[];
  groupList: groupProps[];
  totalCount: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  limit: number;
  getQuantList: () => void;
}

function ReportContent({
  list,
  groupList,
  totalCount,
  currentPage,
  setCurrentPage,
  limit,
  getQuantList,
}: Props) {
  // const limit = 12;
  const { modalDispatch } = useModal();
  const [openInterestModal, setOpenInterestModal] = useState(false);
  const [selectedIdx, setselectedIdx] = useState<number | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<string[]>([]);

  const reverseTypeObj: { [key: string]: number } = {
    저평가주: 0,
    공시지가보다낮주: 1,
    전세가보다낮주: 2,
    전세우위주: 3,
    월세우위주: 4,
    평균보다낮주: 5,
    하자없주: 6,
    시세차익주: 7,
    저평가부실채권주: 8,
    소액투자주: 9,
    시세상승주: 10,
    이자보다월세주: 11,
  };

  function formatKoreanWon(amount: number | string) {
    if (typeof amount === 'string') {
      amount = parseFloat(amount.replace(/,/g, ''));
    }
    if (typeof amount !== 'number' || isNaN(amount) || Math.abs(amount) < 10000)
      return '-';

    const units = [
      { value: 100000000, label: '억 ' },
      { value: 10000, label: '만' },
    ];

    let result = '';
    for (let unit of units) {
      if (amount >= unit.value) {
        const unitCount = Math.floor(amount / unit.value);
        amount %= unit.value;
        result += unitCount + unit.label;
      }
    }

    return result;
  }

  const formatDate = (dateStr: string) => {
    const [dateOnly] = dateStr.split('T');
    const [year, month, day] = dateOnly.split('-');
    return `분석일 ${year.slice(2)}.${month}.${day}`;
  };

  const deleteInterest = async (idx: number) => {
    try {
      await QuantService.deleteInterest(idx);
    } catch (err) {
      console.log(err);
    }
  };

  const handleInterestButton = (idx: number, qh_idx: number, star: boolean) => {
    if (star) {
      const confirmed = window.confirm('관심 리포트에서 삭제하시겠습니까?');
      if (confirmed) {
        deleteInterest(qh_idx);
        getQuantList();
      }
    } else {
      setOpenInterestModal(true);
      setselectedIdx(idx);
    }
  };

  return (
    <Box gap={24}>
      {list.length > 0 && (
        <ItemBox>
          {list.map((item, index) => (
            <ItemMemo key={index}>
              <Item>
                <Box gap={8} style={{ alignContent: 'flex-start' }}>
                  <ItemHeader>
                    <BadgeBox>
                      <Category_Badge>
                        <Text size={12} weight={700} color="#FFFFFF">
                          {item.category}
                        </Text>
                      </Category_Badge>
                      {item?.search_category.length > 0 && (
                        <ThemeBadge
                          hasPopover={item?.search_category.length > 1}
                          onClick={() => {
                            if (item.search_category.length === 1) return;

                            setSelectedTheme(item.search_category);
                            setOpenModal(true);
                          }}
                        >
                          <Text size={12} weight={700} color="#FFFFFF">
                            {item?.search_category[0]}
                          </Text>
                          {item?.search_category.length > 1 && (
                            <img
                              src="/assets/images/plus/plus_white.svg"
                              alt="plus"
                              width={14}
                              height={14}
                            />
                          )}
                        </ThemeBadge>
                      )}
                    </BadgeBox>
                    <img
                      src={
                        item.group_idx
                          ? '/assets/images/icon/star-blue.svg'
                          : '/assets/images/icon/star-gray.svg'
                      }
                      onClick={() => {
                        handleInterestButton(
                          item.quant_idx,
                          item.qh_idx,
                          item.group_idx !== null,
                        );
                      }}
                      alt=""
                    />
                  </ItemHeader>
                  <ItemHeader>
                    <Text size={12} weight={500} color="#37383C9C">
                      {item.caseno} | {item.court}
                    </Text>
                    <Text size={12} weight={500} color="#37383C9C">
                      {formatDate(item.analysis_time)}
                    </Text>
                  </ItemHeader>
                  <Text
                    size={14}
                    weight={700}
                    color="#222222"
                    style={{ textAlign: 'start' }}
                  >
                    {item.region}
                  </Text>
                  <Row gap={4}>
                    {item.tags.map((tag, index) => (
                      <Tag key={index} type={index === 0 ? item.type : 6}>
                        <span>{tag}</span>
                      </Tag>
                    ))}
                  </Row>
                </Box>
                <Box gap={2}>
                  <Row style={{ justifyContent: 'space-between' }}>
                    <Text size={13} weight={500} color="#616161">
                      예상입찰가
                    </Text>
                    <Text size={16} weight={700} color="#222222">
                      {formatKoreanWon(item.ex_bid_prc)}
                    </Text>
                  </Row>
                  <Row style={{ justifyContent: 'space-between' }}>
                    <Text size={13} weight={500} color="#616161">
                      예상매각가
                    </Text>
                    <Text size={16} weight={700} color="#222222">
                      {formatKoreanWon(item.ex_sale_prc)}
                    </Text>
                  </Row>
                  <Row style={{ justifyContent: 'space-between' }}>
                    <Text size={13} weight={500} color="#616161">
                      예상매매차익
                    </Text>
                    <Text size={16} weight={700} color="#F45551">
                      {formatKoreanWon(item.margin)}
                    </Text>
                  </Row>
                </Box>
                <span
                  style={{
                    width: '100%',
                    height: '1px',
                    background: '#E5E8EA',
                  }}
                />
                <R_Container>
                  <Text size={13} weight={500} color="#616161">
                    ROI:{' '}
                    <span style={{ color: '#008AFF' }}>
                      {item.roi ? item.roi : '-'}%
                    </span>
                  </Text>
                  <Text size={13} weight={500} color="#616161">
                    ROE:{' '}
                    <span style={{ color: '#008AFF' }}>
                      {item.roe ? item.roe : '-'}%
                    </span>
                  </Text>
                </R_Container>
                <Btn_RP
                  onClick={async () => {
                    const grade = await userGradeType();
                    if (!grade) {
                      modalDispatch({ type: 'USER_ALERT', payload: 'free' });
                      return;
                    }
                    const typeNumbers = item.search_category
                      .map((name) => reverseTypeObj[name])
                      .filter((num) => num !== undefined);
                    const strategyText = typeNumbers.join(',');
                    window.open(
                      `/quant/vipreport/${item.quant_idx}/${strategyText}`,
                      '_blank',
                    );
                  }}
                  // onClick={() => {
                  //   setSelectedItem(item);
                  //   setOpenReportModal(true);
                  // }}
                >
                  <span>리포트보기</span>
                </Btn_RP>
              </Item>
              {item.group_idx && item.memo && (
                <MemoBox>
                  <Memo>
                    [
                    {
                      groupList.find((g) => g.group_idx === item.group_idx)
                        ?.group
                    }
                    ] {item.memo}
                  </Memo>
                </MemoBox>
              )}
            </ItemMemo>
          ))}
        </ItemBox>
      )}
      {list.length > 0 && (
        <PaginationWrapper>
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalCount / limit)}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            removeMargin={true}
          />
        </PaginationWrapper>
      )}
      {list.length === 0 && <Blink_Box> 물건이 없습니다.</Blink_Box>}
      {openInterestModal && (
        <AddInterestReportModal
          onClose={() => setOpenInterestModal(false)}
          selectedIdx={selectedIdx}
          mode=""
          getQuantList={getQuantList}
        />
      )}
      {openModal && (
        <ThemeModal
          onClose={() => setOpenModal(false)}
          search_category={selectedTheme}
        />
      )}
    </Box>
  );
}

export default ReportContent;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;
const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  color: ${(props) => props.color};
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-bottom: 24px;
  row-gap: 24px;
  column-gap: 24px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 16px;
  gap: 12px;
  border: 1px solid #e5e8ea;
  background: #ffffff;
`;

const ItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  img {
    cursor: pointer;
  }
`;

const ItemMemo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const MemoBox = styled.div`
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e8ea;
  background-color: #fafafb;
`;

const Memo = styled.div`
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;
const Category_Badge = styled.div<{ type?: number }>`
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
  background: #008aff;
  border: 1px solid #008aff;
  width: fit-content;
`;

const R_Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-end;
  align-items: center;
`;

const Btn_RP = styled.button`
  border: none;
  background: #70737c14;
  width: 100%;
  border-radius: 8px;
  padding-top: 9px;
  padding-right: 16px;
  padding-bottom: 9px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;

  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: calc(14px * 0.02);
    color: #616161;
    width: 100%;
    text-align: center;
  }
`;

const Blink_Box = styled.div`
  width: 1200px;
  height: 628px;
  gap: 16px;
  padding-top: 24px;
  padding-right: 16px;
  padding-bottom: 72px;
  padding-left: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const Tag = styled.span<{ type: number }>`
  border-radius: 4px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
  padding-left: 5px;
  background: ${(props) => {
    switch (props.type) {
      case 1:
        return '#E6F4FF';
      case 2:
        return '#F1FCF8';
      case 3:
        return '#FCF5F1';
      case 4:
        return '#F1EEFF';
      case 5:
        return '#FEEFF4';
      default:
        return '#70737C14';
    }
  }};
  span {
    font-family: Spoqa Han Sans Neo;
    font-weight: 500;
    font-size: 12px;
    line-height: 145%;
    letter-spacing: calc(12px * -0.05);
    color: ${(props) => {
      switch (props.type) {
        case 1:
          return '#008AFF';
        case 2:
          return '#27A131';
        case 3:
          return '#EC5717';
        case 4:
          return '#836BF1';
        case 5:
          return '#F45551';
        default:
          return '#37383C9C';
      }
    }};
  }
`;

const PaginationWrapper = styled.div`
  padding-top: 24px;
  padding-bottom: 72px;
`;

const BadgeBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ThemeBadge = styled(Category_Badge)<{ hasPopover: boolean }>`
  background: #d224ca;
  border: none;
  cursor: ${(props) => (props.hasPopover ? 'pointer' : 'default')};
`;
